import React from "react";
import Link from "next/link";
import { makeStyles } from "tss-react/mui";

// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import Card from "../../components/Card/Card.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/landingPageSections/careerZoneGridStyle.js";

import { buildSlug } from "../../util/url";

const useStyles = makeStyles()(styles);

export default function CareerZoneGrid({ data }) {
  const { classes, cx } = useStyles();
  const imageClasses = cx(classes.imgFluid);

  let listItems = [
    <GridItem key="loading" xs={12} sm={12} md={2} className={cx("five_grid")}>
      <h4 className={classes.cardDesc}>Loading...</h4>
    </GridItem>,
  ];

  if (data) {
    listItems = data?.career_zones.map((zone) => (
      <GridItem
        key={`cz-${zone.id}`}
        xs={12}
        sm={12}
        md={2}
        className={cx(classes.noUnderlineLinks, "five_grid")}
      >
        <Link href={`/career-zone/${buildSlug(zone.name)}/${zone.id}`}>
          <Card className={cx(classes.jobCard, "link")}>
            <img
              src={zone.icon_path}
              role="presentation"
              className={classes.icon}
            />
            <h4 className={classes.cardDesc}>{zone.name}</h4>
          </Card>
        </Link>
      </GridItem>
    ));
  }

  return (
    <div className={cx(classes.section, "aassaaasasa")}>
      <div className={cx(classes.container, "sidebar")}>
        <h1 className={classes.cardTitle}>Explore</h1>
        <h4 className={classes.cardSubTitle}>
          Careers, what to study and how to get there.
        </h4>
        <GridContainer
          className={classes.container}
          style={{ maxWidth: "79%", margin: "auto" }}
        >
          {listItems}
        </GridContainer>
      </div>
    </div>
  );
}
